import { getApiErrorMessage } from './errors';
import { apiFetch } from './fetch';

export type BatchRecipientInput = {
  name: string;
  email: string;
  protectionLevel: string;
  recipientUserId?: string;
  phone?: string;
};

export type AddRecipientsBatchResponse = {
  added: number;
  failed: Array<{ email: string; reason: string }>;
};

export async function addRecipientsBatch(
  documentId: string,
  recipients: BatchRecipientInput[],
): Promise<AddRecipientsBatchResponse> {
  const res = await apiFetch(`/api/documents/${documentId}/recipients/batch`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      recipients: recipients.map((r) => ({
        name: r.name,
        email: r.email,
        protectionLevel: r.protectionLevel,
        ...(r.recipientUserId ? { recipientUserId: r.recipientUserId } : {}),
        ...(r.phone ? { phone: r.phone } : {}),
      })),
    }),
  });
  if (!res.ok) {
    const message = await getApiErrorMessage(res);
    throw new Error(message ?? 'batch recipients failed');
  }
  return res.json();
}
